(() => {
  if (window.mtxSectionLocaleFallback) return;
  window.mtxSectionLocaleFallback = true;

  const nodes = document.querySelectorAll('[data-mtx-section-fallback]');
  if (!nodes.length) return;

  const injectHtml = (root, html) => {
    const tmp = document.createElement('div');
    tmp.innerHTML = String(html).trim();

    const heading = root.dataset.heading;
    if (heading) {
      const headingEl = tmp.querySelector('.rich-text__heading, h2');
      if (headingEl) {
        const target = headingEl.querySelector('motion-element') || headingEl;
        target.textContent = heading;
      }
    }

    const localeRoot = (root.dataset.localeRoot || '').replace(/\/$/, '');
    if (localeRoot && localeRoot !== '/') {
      tmp.querySelectorAll('a[href^="/products/"], a[href^="/collections/"]').forEach((link) => {
        const href = link.getAttribute('href');
        if (href && !href.startsWith(`${localeRoot}/`)) {
          link.setAttribute('href', `${localeRoot}${href}`);
        }
      });
    }

    const scripts = [...tmp.querySelectorAll('script')];
    scripts.forEach((script) => script.remove());

    const source = tmp.querySelector('.shopify-section') || tmp;
    const parent = root.parentNode;
    const inserted = [];

    [...source.childNodes].forEach((node) => {
      const clone = node.cloneNode(true);
      parent.insertBefore(clone, root);
      inserted.push(clone);
    });
    root.remove();

    scripts.forEach((oldScript) => {
      const script = document.createElement('script');
      if (oldScript.src) {
        script.src = oldScript.src;
        script.defer = true;
      } else {
        script.textContent = oldScript.textContent;
      }
      document.body.appendChild(script);
    });

    return inserted;
  };

  const loadSection = (root) => {
    const sectionIds = [root.dataset.sectionIdFull, root.dataset.sectionId].filter(Boolean);
    const primaryPath = root.dataset.primaryPath;
    if (!sectionIds.length || !primaryPath) {
      root.remove();
      return;
    }

    const separator = primaryPath.includes('?') ? '&' : '?';
    const url = `${primaryPath}${separator}sections=${sectionIds.map(encodeURIComponent).join(',')}`;

    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error('Section fallback request failed');
        return response.json();
      })
      .then((data) => {
        const html = sectionIds.map((id) => data[id]).find((value) => value && String(value).trim());
        if (!html) {
          root.remove();
          return;
        }

        injectHtml(root, html);
      })
      .catch(() => {
        root.remove();
      });
  };

  nodes.forEach(loadSection);
})();
